import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-college-development-committee',
  templateUrl: './college-development-committee.component.html',
  styleUrls: ['./college-development-committee.component.scss']
})
export class CollegeDevelopmentCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
